import React, { useContext } from "react";

import { ShipmentContext } from "../../contexts/ShipmentContext.jsx";
import { translate, capitalizePhrase } from "../../../utility/strings.js";

const ShipmentInfo = () => {

  let { shipment, loading } = useContext(ShipmentContext);

  const loadingSpan = <span class="font-light h6">Loading...</span>

  const shipmentInfoKeys = shipment?.shipment ? Object.keys(shipment.shipment) : [];

  return (
    <div className="shipment-info container container--narrow my-10">
      <h2 className="h4 mb-3">{translate("shipment_tracking.shipment_info", "Shipment Info")}</h2>
      <div className="shipment-info__items flex justify-between gap-5 wrap sm:no-wrap">
        {shipment && !loading ?
          shipmentInfoKeys.map(key => <div className="shipment-info__item text-lg">
                                        <span class="font-bold">{translate(`shipment_tracking.info.${key}`, `${capitalizePhrase(key.replaceAll("_", " "))}:`)}</span><br/>
                                        <span>{shipment.shipment[key]}</span>
                                      </div>)
        : null }
      </div>
    </div>
  );

}

export default ShipmentInfo;
